import * as React from "react";
const SvgStorefront = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M15 12.75a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75v-1ZM6.5 14.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Z"
      fill="currentColor"
    />
    <path
      d="M3.75 3.016a.75.75 0 0 0-.73.578l-1 4.261a.75.75 0 0 0-.02.171c0 .853.385 1.639 1 2.143V20.25c0 .967.784 1.75 1.75 1.75h14.5A1.75 1.75 0 0 0 21 20.25V10.175a2.775 2.775 0 0 0 1.007-2.149.749.749 0 0 0-.02-.17l-1-4.262a.75.75 0 0 0-.73-.578H3.75Zm15.75 7.726v9.508a.25.25 0 0 1-.25.25H14V10.08a2.523 2.523 0 0 0 3.556-.143 2.523 2.523 0 0 0 1.944.806Zm-7 9.758H4.75a.25.25 0 0 1-.25-.25v-3h8v3.25Zm0-4.75h-8v-5.009a2.523 2.523 0 0 0 1.952-.806 2.523 2.523 0 0 0 3.701 0 2.523 2.523 0 0 0 2.347.76v5.055ZM3.502 8.104l.842-3.588h1.357v3.51c0 .716-.535 1.217-1.1 1.217-.545 0-1.062-.465-1.099-1.139Zm3.7-3.588h2.2V8.05c-.01.703-.54 1.193-1.1 1.193-.565 0-1.1-.5-1.1-1.217v-3.51Zm3.701 3.51v-3.51h2.201v3.51c0 .716-.535 1.217-1.1 1.217-.56 0-1.09-.49-1.101-1.193v-.024Zm5.903-3.51V8.05c-.012.703-.541 1.193-1.1 1.193-.566 0-1.101-.5-1.101-1.217v-3.51h2.2Zm1.5 3.534V4.516h1.357l.842 3.588c-.037.674-.554 1.14-1.099 1.14-.559 0-1.088-.49-1.1-1.194Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgStorefront;
